import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Check, PriorityHigh } from '@mui/icons-material'
import './doxUploaderStatusIcon.scss'

const doxUploaderStatusIcon = ({ uploadStatus }) => {

    let colourClass = 'is-yellow'

    if (uploadStatus === 'success') {
        colourClass = 'is-green'
    }
    if (uploadStatus === 'failed') {
        colourClass = 'is-red'
    }    

    return (
        <div className='return-filing-status'>
            <div className={classnames('icon-holder', colourClass)}>
                {colourClass.includes('is-green') && <Check />}
                {(colourClass.includes('is-yellow') || colourClass.includes('is-red')) && <PriorityHigh />}
            </div>
        </div>
    )
}

doxUploaderStatusIcon.propTypes = {
    uploadStatus: PropTypes.string,
}

export default doxUploaderStatusIcon;
